/**
 * Cookieの有効期限
 */
export const COOKIE_MAX_AGE = {
  ONE_DAY: 60 * 60 * 24, // 1 day
  THREE_DAYS: 60 * 60 * 24 * 3, // 3 days
  ONE_WEEK: 60 * 60 * 24 * 7, // 7 days
  ONE_MONTH: 60 * 60 * 24 * 30, // 30 days
  THREE_MONTHS: 60 * 60 * 24 * 90, // 90 days
  ONE_YEAR: 60 * 60 * 24 * 365, // 1 year
} as const;

/**
 * Server-side only cookie options
 *
 * - `httpOnly: true` な Cookie のため、ブラウザの JavaScript からはアクセスできません。
 * - token などのセキュリティに関わる情報を保存するために使用します。
 * - 有効期限 (`maxAge`) は関数の呼び出し側で必ず設定してください。
 */
export const SERVER_ONLY_COOKIE_OPTIONS = {
  httpOnly: true,
  secure: process.env.NODE_ENV === "production",
  path: "/",
  sameSite: "lax",
} as const;

/**
 * Browser-accessible cookie options
 *
 * - `httpOnly: false` な Cookie のため、ブラウザの JavaScript からアクセスできます。
 * - ブラウザの Cookie を読み取ることができるため、セキュリティに関わる情報を保存するためには使用しません。
 * - 有効期限 (`maxAge`) は関数の呼び出し側で必ず設定してください。
 */
export const BROWSER_ACCESSIBLE_COOKIE_OPTIONS = {
  ...SERVER_ONLY_COOKIE_OPTIONS,
  httpOnly: false,
} as const;
